import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFuturesGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M3 5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25v13.5A2.25 2.25 0 0 1 18.75 21H5.25A2.25 2.25 0 0 1 3 18.75v-4.875a.75.75 0 0 1 1.5 0v4.875c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75v4.5h1.94l2.03-2.03a.75.75 0 0 1 1.085.025l3.153 3.47 3.577-4.553a.75.75 0 1 1 1.18.926l-4.125 5.25a.75.75 0 0 1-1.145.042l-3.22-3.543L7.28 11.03a.75.75 0 0 1-.53.22h-3A.75.75 0 0 1 3 10.5V5.25Z"
    />
    <path
      fill="#F7A600"
      d="M6 16.5a.75.75 0 0 1 .75-.75h10.875a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 16.5Z"
    />
  </svg>
);
export default SvgTwoColorFuturesGrid;
